// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AggregateFunctionEnum,
    AggregateFunctionEnumFromJSON,
    AggregateFunctionEnumToJSON,
} from '../models/AggregateFunctionEnum';
import {
    type AggregateReadResponse,
    AggregateReadResponseFromJSON,
    AggregateReadResponseToJSON,
} from '../models/AggregateReadResponse';
import {
    type HistoryReadResponse,
    HistoryReadResponseFromJSON,
    HistoryReadResponseToJSON,
} from '../models/HistoryReadResponse';

export interface ExportValuesRequest {
    /**
     * browsename of the device
     */
    deviceId: string;
    /**
     * Start of time range (ISO 8601)
     */
    startTime: Date;
    /**
     * Restrict the export to a single FunctionalUnit (browsename). Required when functionId is given.
     */
    functionalUnitId?: string;
    /**
     * Restrict the export to a single function (browsename). Requires functionalUnitId.
     */
    functionId?: string;
    /**
     * End of time range (ISO 8601). Defaults to current time if omitted.
     */
    endTime?: Date;
}

export interface ReadAggregateValueRequest {
    /**
     * browsename of the device
     */
    deviceId: string;
    /**
     * browsename of the functionalUnit
     */
    functionalUnitId: string;
    /**
     * browsename of the function
     */
    functionId: string;
    /**
     * Start of time range (ISO 8601)
     */
    startTime: Date;
    /**
     * Aggregate function to apply
     */
    aggregateFunction: AggregateFunctionEnum;
    /**
     * Bucket size in milliseconds (e.g., 3600000 = 1 hour)
     */
    processingInterval: number;
    /**
     * End of time range (ISO 8601). Defaults to current time if omitted.
     */
    endTime?: Date;
    /**
     * Optional path to specific value variable (e.g., "SensorValue", "CurrentValue")
     */
    variablePath?: string;
}

export interface ReadHistoryValueRequest {
    /**
     * browsename of the device
     */
    deviceId: string;
    /**
     * browsename of the functionalUnit
     */
    functionalUnitId: string;
    /**
     * browsename of the function
     */
    functionId: string;
    /**
     * Start of time range (ISO 8601)
     */
    startTime: Date;
    /**
     * End of time range (ISO 8601). Defaults to current time if omitted.
     */
    endTime?: Date;
    /**
     * Maximum number of values to return
     */
    numValuesPerNode?: number;
    /**
     * Continuation point from a previous response to fetch the next page of results
     */
    continuationPoint?: string;
}

/**
 * 
 */
export class HistoryApi extends runtime.BaseAPI {

    /**
     * Creates request options for exportValues without sending the request
     */
    async exportValuesRequestOpts(requestParameters: ExportValuesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling exportValues().'
            );
        }

        if (requestParameters['startTime'] == null) {
            throw new runtime.RequiredError(
                'startTime',
                'Required parameter "startTime" was null or undefined when calling exportValues().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['functionalUnitId'] != null) {
            queryParameters['functionalUnitId'] = requestParameters['functionalUnitId'];
        }

        if (requestParameters['functionId'] != null) {
            queryParameters['functionId'] = requestParameters['functionId'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = (requestParameters['startTime'] as any).toISOString();
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = (requestParameters['endTime'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/history/{deviceId}/export`;
        urlPath = urlPath.replace('{deviceId}', encodeURIComponent(String(requestParameters['deviceId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Streams an XLSX workbook aggregated to 1-minute buckets over a gap-free timestamp grid. The sourceTimestamp is used and minutes without recorded data stay empty. Scope narrows with the optional query parameters: - neither given — every FunctionalUnit of the entry (workplace, device or storage), including cross-mounted ones, becomes its own worksheet tab. - functionalUnitId — that single FunctionalUnit as one worksheet. - functionalUnitId + functionId — that single function as one worksheet.
     * Export historical values of a DeviceSet entry as XLSX
     */
    async exportValuesRaw(requestParameters: ExportValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const requestOptions = await this.exportValuesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Streams an XLSX workbook aggregated to 1-minute buckets over a gap-free timestamp grid. The sourceTimestamp is used and minutes without recorded data stay empty. Scope narrows with the optional query parameters: - neither given — every FunctionalUnit of the entry (workplace, device or storage), including cross-mounted ones, becomes its own worksheet tab. - functionalUnitId — that single FunctionalUnit as one worksheet. - functionalUnitId + functionId — that single function as one worksheet.
     * Export historical values of a DeviceSet entry as XLSX
     */
    async exportValues(requestParameters: ExportValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportValuesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for readAggregateValue without sending the request
     */
    async readAggregateValueRequestOpts(requestParameters: ReadAggregateValueRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling readAggregateValue().'
            );
        }

        if (requestParameters['functionalUnitId'] == null) {
            throw new runtime.RequiredError(
                'functionalUnitId',
                'Required parameter "functionalUnitId" was null or undefined when calling readAggregateValue().'
            );
        }

        if (requestParameters['functionId'] == null) {
            throw new runtime.RequiredError(
                'functionId',
                'Required parameter "functionId" was null or undefined when calling readAggregateValue().'
            );
        }

        if (requestParameters['startTime'] == null) {
            throw new runtime.RequiredError(
                'startTime',
                'Required parameter "startTime" was null or undefined when calling readAggregateValue().'
            );
        }

        if (requestParameters['aggregateFunction'] == null) {
            throw new runtime.RequiredError(
                'aggregateFunction',
                'Required parameter "aggregateFunction" was null or undefined when calling readAggregateValue().'
            );
        }

        if (requestParameters['processingInterval'] == null) {
            throw new runtime.RequiredError(
                'processingInterval',
                'Required parameter "processingInterval" was null or undefined when calling readAggregateValue().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = (requestParameters['startTime'] as any).toISOString();
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = (requestParameters['endTime'] as any).toISOString();
        }

        if (requestParameters['aggregateFunction'] != null) {
            queryParameters['aggregateFunction'] = requestParameters['aggregateFunction'];
        }

        if (requestParameters['processingInterval'] != null) {
            queryParameters['processingInterval'] = requestParameters['processingInterval'];
        }

        if (requestParameters['variablePath'] != null) {
            queryParameters['variablePath'] = requestParameters['variablePath'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/history/{deviceId}/FunctionalUnitSet/{functionalUnitId}/FunctionSet/{functionId}/aggregate`;
        urlPath = urlPath.replace('{deviceId}', encodeURIComponent(String(requestParameters['deviceId'])));
        urlPath = urlPath.replace('{functionalUnitId}', encodeURIComponent(String(requestParameters['functionalUnitId'])));
        urlPath = urlPath.replace('{functionId}', encodeURIComponent(String(requestParameters['functionId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns aggregated historical data (Average, Min, Max, etc.) for a function
     * Read aggregated historical values
     */
    async readAggregateValueRaw(requestParameters: ReadAggregateValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AggregateReadResponse>> {
        const requestOptions = await this.readAggregateValueRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AggregateReadResponseFromJSON(jsonValue));
    }

    /**
     * Returns aggregated historical data (Average, Min, Max, etc.) for a function
     * Read aggregated historical values
     */
    async readAggregateValue(requestParameters: ReadAggregateValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AggregateReadResponse> {
        const response = await this.readAggregateValueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for readHistoryValue without sending the request
     */
    async readHistoryValueRequestOpts(requestParameters: ReadHistoryValueRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling readHistoryValue().'
            );
        }

        if (requestParameters['functionalUnitId'] == null) {
            throw new runtime.RequiredError(
                'functionalUnitId',
                'Required parameter "functionalUnitId" was null or undefined when calling readHistoryValue().'
            );
        }

        if (requestParameters['functionId'] == null) {
            throw new runtime.RequiredError(
                'functionId',
                'Required parameter "functionId" was null or undefined when calling readHistoryValue().'
            );
        }

        if (requestParameters['startTime'] == null) {
            throw new runtime.RequiredError(
                'startTime',
                'Required parameter "startTime" was null or undefined when calling readHistoryValue().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = (requestParameters['startTime'] as any).toISOString();
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = (requestParameters['endTime'] as any).toISOString();
        }

        if (requestParameters['numValuesPerNode'] != null) {
            queryParameters['numValuesPerNode'] = requestParameters['numValuesPerNode'];
        }

        if (requestParameters['continuationPoint'] != null) {
            queryParameters['continuationPoint'] = requestParameters['continuationPoint'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/history/{deviceId}/FunctionalUnitSet/{functionalUnitId}/FunctionSet/{functionId}/values`;
        urlPath = urlPath.replace('{deviceId}', encodeURIComponent(String(requestParameters['deviceId'])));
        urlPath = urlPath.replace('{functionalUnitId}', encodeURIComponent(String(requestParameters['functionalUnitId'])));
        urlPath = urlPath.replace('{functionId}', encodeURIComponent(String(requestParameters['functionId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns raw historical data points for a function\'s SensorValue or CurrentValue
     * Read raw historical values
     */
    async readHistoryValueRaw(requestParameters: ReadHistoryValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HistoryReadResponse>> {
        const requestOptions = await this.readHistoryValueRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HistoryReadResponseFromJSON(jsonValue));
    }

    /**
     * Returns raw historical data points for a function\'s SensorValue or CurrentValue
     * Read raw historical values
     */
    async readHistoryValue(requestParameters: ReadHistoryValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HistoryReadResponse> {
        const response = await this.readHistoryValueRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
